module.exports = __webpack_public_path__ + "img/autoamerics-original-480.4a38b3f7.webp";